import { MultipleAutocompleteAdapter } from 'components/enhanced/form/adapters/selects/MultipleAutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { required } from 'components/helpers/validators';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { examService } from 'shared/services';
import { Option } from 'shared/types/general';
import { IMacroExam } from '../types';

interface MacroExamFormProps {
  macroExam: IMacroExam;
  onSubmit: any;
}

function MacroExamForm({ onSubmit, macroExam }: MacroExamFormProps) {
  const { t } = useTranslation();

  const [exams, setExams] = useState<Option[]>([]);

  useEffect(() => {
    examService.getAllBaseInformation().then(setExams);
  }, []);

  return (
    <>
      {macroExam && (
        <EnhancedForm onSubmit={onSubmit} autoStyleLayout columns={5}>
          <IdentityField
            gridSpan={2}
            name="code"
            initialValue={macroExam.code}
            component={TextFieldAdapter}
            label={t('global.code')}
            type="text"
            validate={required}
            required
          />
          <IdentityField
            gridSpan={3}
            name="description"
            initialValue={macroExam.description}
            component={TextFieldAdapter}
            label={t('global.description')}
            type="text"
          />
          <IdentityField
            gridSpan={5}
            name="exams"
            component={MultipleAutocompleteAdapter}
            options={exams}
            initValue={macroExam.exams}
            label={t('global.exams')}
            type="text"
          />
        </EnhancedForm>
      )}
    </>
  );
}

export default MacroExamForm;
